import React from 'react'
import PropTypes from 'prop-types'
import { Box, Clickable, Icon } from '@maui/elements'
import { formatLongDate, formatBytes, downloadFile } from '../../../../../utilities'

export const Attachment = ({ item, canDownload }) => {
  const { created_at: date, file_name: name, id, file_size: size } = item
  const dateStr = `Uploaded ${formatLongDate(date)}`

  return (
    <Box
      color='colorTextMain'
      borderBottomWidth='1px'
      borderBottomColor='colorBorderMain'
      borderBottomStyle='solid'
    >
      <Box display='flex' height='32px' alignItems='center'>
        <Box flex='1' display='flex'>
          <Box
            variant='body2'
            fontWeight='600'
            width='240px'
            overflow='hidden'
            whiteSpace='nowrap'
            textOverflow='ellipsis'
            cursor='pointer'
            title={name}
          >{name}</Box>
          <Box
            variant='body2'
            paddingLeft='spaceGapSmall'
            paddingRight='spaceGapSmall'
            color='colorTextDeemphasis'
          > - </Box>
          <Box
            variant='body2'
            color='colorTextDeemphasis'
          >{dateStr}</Box>
          <Box
            variant='body2'
            color='colorTextDeemphasis'
            marginLeft='spaceGapMedium'
          >{formatBytes(size)}</Box>
        </Box>
        { canDownload && (
          <Clickable as='a' onClick={() => downloadFile(id, name)}>
            <Icon as='a' name='download' color='colorActionPrimary' />
          </Clickable>
        )}
      </Box>
    </Box>
  )
}

Attachment.propTypes = {
  item: PropTypes.shape({
    created_at: PropTypes.string,
    file_name: PropTypes.string,
    file_size: PropTypes.string,
    id: PropTypes.string,
  }),
  canDownload: PropTypes.bool,
}
